var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.textGroup)?_c(_vm.workListComponent,{tag:"component",attrs:{"text-group":_vm.textGroup,"work-deck-component":_vm.workDeckComponent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }